export const TABLETOOLTIPS = {
    'price': "Price for the player",
    'playerRole': "player role",
    'points': "points",
    "season": "Year game was played",
    'round': "Round of the game",
    'Rd': "Round of the game"
}